import { TBreakdownReasonsActions } from './breakdown-reasons.actions';
import { TBreakdownReasonsState, TBreakdownReasonsInfoActionType } from './breakdown-reasons.models';
import { LIST_ITEMS_PER_PAGE_LIST } from '../../constants/constants';

export const intialState: TBreakdownReasonsState = {
  breakdownReasonsListingInfo: null,
  breakdownReasonsDropdown: null,
  breakdownReasonsPagination: { pageNo: 1, pageSize: LIST_ITEMS_PER_PAGE_LIST[0] },
};

export function breakdownReasonsReducer(state = intialState, action: TBreakdownReasonsActions): TBreakdownReasonsState {
  switch (action.type) {
    case TBreakdownReasonsInfoActionType.SetBreakdownReasonsPagination:
      return {
        ...state,
        breakdownReasonsPagination: action.pagination,
      };
    case TBreakdownReasonsInfoActionType.GetBreakdownReasonsListSuccess:
      return {
        ...state,
        breakdownReasonsListingInfo: {
          res: action.res,
          fetchReason: action.fetchReason,
        },
      };
    case TBreakdownReasonsInfoActionType.GetBreakdownReasonsListFailure:
      return {
        ...state,
        breakdownReasonsListingInfo: null,
      };
    case TBreakdownReasonsInfoActionType.GetBreakdownReasonsListFilterDropDownSuccess:
      return {
        ...state,
        breakdownReasonsDropdown: action.dropdownRes,
      };
    case TBreakdownReasonsInfoActionType.GetBreakdownReasonsListFilterDropDownFailure:
      return {
        ...state,
        breakdownReasonsDropdown: null,
      };
    default:
      return state;
  }
}
